import {Card, Container, styled} from '@mui/material';

export const StyledCard = styled(Card)`
	max-width: 852px;
	padding: 16px;
	display: flex;
	flex-direction: column;
	justify-items: center;
	gap: 16px;
	margin: 0 auto;

	${({theme}) => theme.breakpoints.up('sm')} {
		padding: 24px;
		flex-direction: row;
	}
`;

export const StyledContainer = styled(Container)`
	padding: 16px;
	margin-bottom: 108px;

	${({theme}) => theme.breakpoints.up('sm')} {
		padding: 32px;
	}
`;

export const StyledImage = styled('div')`
	margin: 0 auto;

	img {
		width: 280px;
	}

	${({theme}) => theme.breakpoints.up('sm')} {
		img {
			width: 360px;
		}
	}
`;

export const StyledLabel = styled('label')`
	color: ${({theme}) => theme.palette.text.secondary};
	font-weight: 600;
`;
